import type { CSSProperties } from 'react';

/** The outlined green look shared by Add replacement, Mark picked up and Undo. */
export const OUTLINE_ACTION_STYLE: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  color: 'var(--nb-primary)',
  borderColor: 'var(--nb-primary)',
  fontWeight: 600,
};

/** Grey supporting text: the pickup status and the notes. */
export const TREE_REPLACEMENT_MUTED: CSSProperties = {
  fontSize: 11,
  color: 'var(--nb-subtle)',
  lineHeight: 1.45,
  overflowWrap: 'break-word',
  minWidth: 0,
};

export type TreeReplacementLayout = 'columns' | 'stacked';

/** Below this list width the columns stop fitting and each row stacks. */
export const TREE_REPLACEMENT_COLUMNS_MIN_WIDTH = 560;

/** One grid for the header and every row, so the columns line up. Stacked rows put
 *  the name, trees and notes on their own lines and the status beside the action. */
export const TREE_REPLACEMENT_GRID: Record<TreeReplacementLayout, CSSProperties> = {
  columns: {
    display: 'grid',
    gridTemplateColumns:
      'minmax(110px, 1.2fr) minmax(90px, 1fr) minmax(0, 1.8fr) minmax(110px, 1.4fr) auto',
    gridTemplateAreas: '"name trees note status action"',
    columnGap: 12,
    alignItems: 'center',
  },
  stacked: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    gridTemplateAreas: '"name name" "trees trees" "note note" "status action"',
    columnGap: 10,
    rowGap: 2,
    alignItems: 'center',
  },
};
